import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
// Components
import PurchaseOrderApprovalTable from "./PurchaseOrderApprovalTable"; //reused table component

//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import {isLoggedIn} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";


const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const PurchaseApprovalHistoryView = () => {
	const { pono, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState(null);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [notes, setNotes] = useState('');

	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const data = async () => {
		const po_details = await axios.get(process.env.REACT_APP_API_URL+'get_po_details', {
			params:{
				pono: pono,
				jc_u_idno: branchidno
			}
		});
		if(po_details){
			setItems(po_details.data.data[0].item_info);
			setSupplierInfo(po_details.data.data[1].po_info);
			setShipTotal(po_details.data.data[1].po_info.shipping);
			setPoTotal(po_details.data.data[1].po_info.subtotal);
			setGrandTotal(po_details.data.data[1].po_info.total);
			setNotes(po_details.data.data[1].po_info.notes);
		}
		//setTotal(parseInt(poTotal) + parseInt(shipTotal));
		console.log(po_details.data.data[1].po_info.total);
	};	

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/purchases"}><h4 style={{color:"#339933"}}>Purchases</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/purchases/purchases-order-approval-history"}><h4 style={{color:"#339933"}}>Purchase Order Approval History</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Purchase Order #{pono}</h4>
				{/* <h4>supplier id: {supid} - delivery_date: {delivery_date}</h4> test if param values were passed*/}
			</div>
			     {supplierInfo?(			<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Purchase Order Approval History Information
								</div>
								<div className={classes.title}>
									{"Purchased From"}
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								{/* <PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/> */}
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								{/* <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/> */}
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4}  className={classes.infoTitle}>
									Date of Delivery: 
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.delivery_date || "Date of delivery"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4}  className={classes.infoTitle}>
									Contact Person: 
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.contact_person || "Purchased From"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4}  className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.mode_of_payment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4}  className={classes.infoTitle}>
									Contact #:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.contact_number || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4}  className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.address || "Address"}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderApprovalTable items={items} setItems={setItems}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{/* Shipping: 0.00	shipTotal	 */}
									{"Shipping: "+ shipTotal}							
								</div>
								<div style={{textAlign:"right"}}className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "+ numeral(poTotal).format('0,0.00')}
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(grandTotal).format('0,0.00')}
								</div>	
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
			</div>
		):(<Preloader />)}

		</div>
	);
};

export default PurchaseApprovalHistoryView;
